<template>
  <!-- <v-chip :label="isLabel" small :color="getColor(text)" dark>{{text}}</v-chip> -->
  <a-chip small outlined :class="getPriorityClass(text)">{{ getData(text) }}</a-chip>
</template>

<script>
export default {
  name: "ColoredChipTemplate",
  data: function () {
    return { data: { data: {} }, isLabel: false };
  },
  props: {
    chipColumn: String,
    textValue: String,
  },
  computed: {
    priorities() {
      return [
        {
          text: this.$t("agenda.lblHigh"),
          value: "High",
        },
        {
          text: this.$t("agenda.lblMedium"),
          value: "Medium",
        },
        {
          text: this.$t("agenda.lblLow"),
          value: "Low",
        },
      ]
    },
    frequencies() {
      return [
        {
          text: this.$t("agenda.lblAnnually"),
          value: "Annually",
        },
        {
          text: this.$t("agenda.lblQuarterly"),
          value: "Quarterly",
        },
        {
          text: this.$t("agenda.lblMonthly"),
          value: "Monthly",
        },
        {
          text: this.$t("agenda.lblAdhoc"),
          value: "Adhoc",
        },
      ]
    },
    text() {
      //alert(this.chipColumn);
      if (this.textValue != "") {
        return this.textValue;
      }
      if (this.chipColumn === "priority") {
        return this.data.priority;
      }
      if (this.chipColumn === "frequency") {
        return this.data.frequency;
      }
      if (this.chipColumn === "resolution") {
        return this.data.resolutionType;
      }
      return this.data.priority;
    },
  },
  methods: {
    getData(text) {
      if(text) {
        if(this.chipColumn === "priority") {
          let priorityData = this.priorities.filter((obj) => obj.value === text);
          return priorityData.length > 0 ? priorityData[0].text : text;
        }
        if(this.chipColumn === "frequency") {
          let frequencyData = this.frequencies.filter((obj) => obj.value === text);
          return frequencyData.length > 0 ? frequencyData[0].text : text;
        }
        else {
          return text;
        }
      }  
    },
    getPriorityClass(text) {
      return String(text).toLowerCase();
    },
    getColor(text) {
      if (this.chipColumn === "priority") {
        this.isLabel = false;
        return this.getPriorityColors(text);
      }

      if (this.chipColumn === "frequency") {
        this.isLabel = true;
        return this.getFrequencyColors(text);
      }

      if (this.chipColumn === "resolution") {
        this.isLabel = true;
        return this.getResolutionColors(text);
      }
    },
    getPriorityColors(priority) {
      switch (priority.toLowerCase()) {
        case "high":
          return "error lighten-1";
        case "medium":
          return "warning";
        case "low":
          return "primary lighten-1";
        default:
          return "secondary lighten-1";
      }
    },

    getFrequencyColors(frequency) {
      switch (frequency.toLowerCase()) {
        case "annually":
          return "primary lighten-1";
        case "quarterly":
          return "teal lighten-1";
        case "monthly":
          return "warning darken-3";
        default:
          return "secondary lighten-1";
      }
    },

    getResolutionColors(resolution) {
      switch (resolution.toLowerCase()) {
        case "in person":
          return "warning darken-4";
        case "in writing":
          return "purple lighten-1";

        case "remote":
          return "primary";
        case "hybrid":
          return "teal";
        default:
          return "secondary lighten-1";
      }
    },
  },
};
</script>